import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError} from "../../../../../../../../logics/api_config";
import {useApiRentriCalls} from "../../../api-hooks/api_rentri_config";
import {
    IRentriMateriale
} from "../../../../../../../../utils/interfaces/special_wasty/rentri/codifiche/rifiuto/IRentriMateriale";


const useApiGetRentriMateriale = (): UseQueryResult<IRentriMateriale[], CustomAxiosError> => {
    const {get} = useApiRentriCalls()

    async function doGet(): Promise<IRentriMateriale[]> {
        try {
            const response = await get(`/codifiche/v1.0/lookup/materiali`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetRentriMateriale"],
        queryFn: () => doGet(),
    })
};

export default useApiGetRentriMateriale